import PILComponent from '../../common/PILComponent';
import styles from '../styles/automationNew.module.scss';

const PIL_TYPE_BY_STATUS = {
  completed: 'success',
  running: 'loading',
  connecting: 'loading',
  live: 'loading',
  error: 'error',
  warning: 'warning',
  stopped: 'error',
  pending: 'disabled',
  idle: 'disabled',
};

function normalizeStatus(status) {
  return String(status || '').toLowerCase();
}

export function statusToPilType(status) {
  return PIL_TYPE_BY_STATUS[normalizeStatus(status)] || 'disabled';
}

export function dotClassForStatus(status) {
  const key = normalizeStatus(status);
  const variant = {
    completed: styles.dot_completed,
    running: styles.dot_running,
    live: styles.dot_running,
    connecting: styles.dot_connecting,
    error: styles.dot_error,
    warning: styles.dot_error,
    stopped: styles.dot_error,
  }[key] || styles.dot_idle;
  return `${styles.liveDot} ${variant}`;
}

const NUMBER_BADGE_BY_STATUS = {
  completed: styles.instNumberBadge_completed,
  running: styles.instNumberBadge_running,
  connecting: styles.instNumberBadge_running,
  live: styles.instNumberBadge_running,
  error: styles.instNumberBadge_error,
  warning: styles.instNumberBadge_error,
  stopped: styles.instNumberBadge_error,
  pending: styles.instNumberBadge_pending,
  idle: styles.instNumberBadge_pending,
};

/**
 * Status display for Automation New — wraps the shared app PILComponent
 * (pil.module.scss color tokens) so status colors match the rest of the product.
 * Circular step indices use tokenized number badges (PIL is label-shaped).
 */
export default function StatusPill({ status, label, number = false }) {
  const key = normalizeStatus(status);
  const display = label != null ? String(label) : String(status || 'pending');

  if (number) {
    const badgeVariant = NUMBER_BADGE_BY_STATUS[key] || styles.instNumberBadge_pending;
    return (
      <span
        className={`${styles.instNumberBadge} ${badgeVariant}`}
        aria-label={`Step ${display}`}
      >
        {display}
      </span>
    );
  }

  return (
    <PILComponent
      label={display}
      type={statusToPilType(key)}
      size="small"
    />
  );
}
